import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import signupLogin01 from "@/assets/images/help/signup-login-01.png";
import signupLogin02 from "@/assets/images/help/signup-login-02.png";
import signupLogin03 from "@/assets/images/help/signup-login-03.png";
import signupLogin04 from "@/assets/images/help/signup-login-04.png";
import signupLogin05 from "@/assets/images/help/signup-login-05.png";
import signupLogin06 from "@/assets/images/help/signup-login-06.png";

export default function HelpSignupLogin() {
  const navigate = useNavigate();

  const steps = [
    {
      title: 'Step 1: Click "Sign up" Button',
      description: 'Click the "Sign up" button on the login screen.',
      image: signupLogin01,
    },
    {
      title: "Step 2: Enter Your Information",
      description: "Enter a valid email address, your name, and a password.",
      image: signupLogin02,
    },
    {
      title: "Step 3: Check Verification Email",
      description:
        'Email verification is required to complete the sign-up process.\nGo to the email you registered and check the verification email.\n(If you don\'t see the email, please check your spam folder.)',
      image: signupLogin03,
    },
    {
      title: "Step 4: Confirm Your Email",
      description:
        'Open the verification email and click the "Confirm Email" button to complete your sign-up.',
      image: signupLogin04,
    },
    {
      title: "Step 5: Log In to Your Account",
      description:
        "On the login screen, enter the email and password you used to sign up, and then log in.",
      image: signupLogin05,
    },
    {
      title: "Step 6: Access Home Screen",
      description: "You will be taken to the home screen.",
      image: signupLogin06,
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-6">
          <h1 className="text-2xl font-bold mb-2">
            Beginner's Guide: Sign Up & Login
          </h1>
          <p className="text-sm text-muted-foreground">
            For first-time users of Fellas Card, please follow the steps below
            to sign up and log in.
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-8">
          {steps.map((step, index) => (
            <div key={index} className="space-y-4">
              <h3 className="text-lg font-bold opacity-90">{step.title}</h3>
              <p className="text-sm font-semibold whitespace-pre-line">
                {step.description}
              </p>
              <div className="rounded-lg overflow-hidden shadow-md">
                <img
                  src={step.image}
                  alt={`Step ${index + 1}`}
                  className="w-full h-auto"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/2")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: User Verification Process</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
